import React from 'react';
import { FDStack, FDBox } from '@facet-wealth/design';

import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import metaOverrideSet from '../../metaOverrideSet';

const AdditionalDetailsSubSection = ({ resource }) => {
  return (
    <FDBox paddingY={2}>
      <FDStack direction={'column'} spacing={1}>
        <MetaControl resource={resource} attrName={'subSectionTitle'} metaOverrideSet={metaOverrideSet} />
        <MetaControl resource={resource} attrName={'subSectionBody'} metaOverrideSet={metaOverrideSet} />
      </FDStack>
    </FDBox>
  );
};

AdditionalDetailsSubSection.defaultProps = {};

AdditionalDetailsSubSection.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AdditionalDetailsSubSection;
